module.exports = __webpack_public_path__ + "assets/img/vue_graph.202076ad.jpg";